<mg-filter-form [filter]="filter" [formGroup]="form">
    <ng-container quickFilter>
        <mat-form-field>
            <input matInput placeholder="Naam" formControlName="name" name="Name">
            <button matSuffix mat-icon-button type="button" (click)="clear('name')" type="button" tabindex="-1">
                <mat-icon>close</mat-icon>
            </button>
        </mat-form-field>
        <!-- <mat-slide-toggle matInput placeholder="Toegang tot DLA App" formControlName="hasAppAccess" name="HasAppAccess" (change)="search()">Toegang tot DLA App</mat-slide-toggle> -->
    </ng-container>
</mg-filter-form>